import { Modal, message, Select, Input, Button } from "antd";
import React, { useState, useEffect, useRef } from "react";
import { putRequest } from "../../service";
import { getChangedFields } from "../../utils/getChangedFields";

const PaymentEdit = (props) => {
  const { open, onRequestClose, employee } = props;
  const [form, setForm] = useState({
    payment_type: "",
    bank_name: "",
    account_title: "",
    account_number: "",
    ibn_number: ""
  });
  const originalFormRef = useRef({});

  const paymentOptions = [
    { value: "bank", label: "Bank Transfer" },
    { value: "cash", label: "Cash" },
    { value: "cheque", label: "Cheque" },
  ];

  useEffect(() => {
    if (employee) {
      const initialData = {
        payment_type: employee.payment_type || "",
        bank_name: employee.bank_name || "",
        account_title: employee.account_title || "",
        account_number: employee.account_number || "",
        ibn_number: employee.ibn_number || ""
      };
      setForm(initialData);
      originalFormRef.current = initialData;
    }
  }, [employee]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSelectChange = (value, name) => {
    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    try {
      const payload = getChangedFields(originalFormRef.current, form);
      if (Object.keys(payload).length === 0) {
        message.info("No changes to update");
        return;
      }
      const response = await putRequest(`/api/employees?employeeId=${employee._id}`, payload);
      if (response.message === 'Employee updated successfully (some related data could not be loaded)') {
        message.success('Employee updated successfully')
        onRequestClose();
      }
      else {
        message.error(response.message || "Employee not updated")
      }
    } catch (error) {
      console.error('Error updating employee:', error);
    }
  };

  return (
    <Modal
      title="Payment Information"
      open={open}
      onCancel={onRequestClose}
      footer={null}
      width={800}
    >
      <div className="bg-white h-[55vh] overflow-auto">
        <div className="bg-form-bg rounded-md px-4 flex flex-col gap-6 py-8">
          <div className="flex flex-col gap-1">
            <label htmlFor="payment_type" className="text-md">
              Salary Payment Method
            </label>
            <Select
              className="w-full"
              placeholder="Select Payment Method"
              name="payment_type"
              onChange={(value) => handleSelectChange(value, "payment_type")}
              value={form.payment_type}
              options={paymentOptions}
            />
          </div>
          {form.payment_type === "bank" && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex flex-col gap-1">
                <label htmlFor="bank_name" className="text-md">
                  Bank Name
                </label>
                <Input
                  placeholder="Bank Name"
                  name="bank_name"
                  value={form.bank_name}
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col gap-1">
                <label htmlFor="account_title" className="text-md">
                  Account Title
                </label>
                <Input
                  placeholder="Account Title"
                  name="account_title"
                  value={form.account_title}
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col gap-1">
                <label htmlFor="account_number" className="text-md">
                  Account Number
                </label>
                <Input
                  placeholder="Account Number"
                  name="account_number"
                  value={form.account_number}
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col gap-1">
                <label htmlFor="ibn_number" className="text-md">
                  IBAN Number
                </label>
                <Input
                  placeholder="IBAN Number"
                  name="ibn_number"
                  value={form.ibn_number}
                  onChange={handleChange}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="flex items-center justify-end gap-3 my-2">
        <Button onClick={onRequestClose} >Cancel</Button>
        <Button
          onClick={handleSubmit}
          type="primary"
          className="bg-primary text-white"
        >
          Update Payment
        </Button>
      </div>
        
    </Modal>
  );
};

export default PaymentEdit;
